export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";